export default {
  chartTitle: 'TIME & SALES',
  busdChartTitle: 'Times & BU/SD Volume',
  chartLegend: {
    buyUp: 'Buy Up',
    sellDown: 'Sell Down',
    unidentified: 'Unidentified',
    price: 'Price',
  },

  listTitleTable: {
    time: 'TIME',
    type: 'TYPE',
    lastPrice: 'LAST PRICE',
    change: 'CHANGE',
    percent1Dchange: '% 1D CHANGE',
    lastVolume: 'LAST SHARES',
    totalVolume: 'TOTAL SHARES',
  },
  table: 'Table',
  chart: 'Chart',
  tab: {
    today: 'Today',
    oneWeek: '5 Days',
    oneMonth: '20 Days',
    // oneQuarter: '60 Days',
  },
  tooltip: {
    price: 'Price: %{value}',
    volume: 'Volume: %{value}',
  },
  volume: 'Volume',
};
